// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
//import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
//import CenteredBlogCard from "examples/Cards/BlogCards/CenteredBlogCard";
import MKTypography from "components/MKTypography";
//import cource1 from "assets/images/cource1.jpg";
//import cource2 from "assets/images/2tankDive.jpg";
import BritishSergeant from "assets/images/BritishSergeant.JPG";
import ladyMccallum from "assets/images/ladyMccallum.jpg";
import ShipGraveyard from "assets/images/ShipGraveyard.jpg";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import { CardContent, Typography } from "@mui/material";
import CatalinaPlane from "assets/images/CatalinaPlane.jpg";
function Wrecksite() {
  return (
    <MKBox component="section" py={2}>
      <Container>
        <Grid item xs={12} lg={6}>
          <MKTypography variant="h3" mt={3} mb={0}>
            Wreck sites...
          </MKTypography>
          <MKTypography variant="body1" mt={4} mb={0}>
            Sri Lanka’s coastline is home to some of the most fascinating wreck dives in South Asia.
            From historic merchant ships to World War II vessels, these underwater relics are now
            thriving artificial reefs, teeming with marine life.
          </MKTypography>
        </Grid>
      </Container>
      <Container>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} lg={6}>
            <MKTypography variant="h3" mt={-10} mb={0}>
              British Sargent
            </MKTypography>
            <MKTypography variant="body1" mt={1} mb={0}>
              The British Sergeant, a 122-meter British oil tanker, was sunk during World War II off
              the coast of Trincomalee in 1942. Today, it rests at around 24 meters deep and has
              become one of Sri Lanka’s most iconic wreck dives. Divers can explore its broken hull,
              massive structures, and the marine life that has made this wartime relic its home.
              Schools of snappers, lionfish, and moray eels are often spotted weaving through its
              rusting remains, making it a dream site for both history lovers and underwater
              photographers.
            </MKTypography>
          </Grid>
          <Grid item xs={12} lg={6} sx={{ ml: "auto", mt: { xs: 8, lg: 8 } }}>
            <Card sx={{ maxWidth: 700, borderRadius: 1, boxShadow: 0 }}>
              <CardMedia
                component="img"
                image={BritishSergeant}
                alt="Team Member"
                sx={{ height: 300, objectFit: "cover" }}
              />
              <CardContent>
                <Typography variant="body1" align="center" fontWeight="bold">
                  British Sargent
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
      <Container>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} lg={6}>
            <MKTypography variant="h3" mt={-10} mb={0}>
              Lady Macculum
            </MKTypography>
            <MKTypography variant="body1" mt={1} mb={0}>
              The Lady McCullum was a British passenger and cargo steamship that sank off the coast
              of Trincomalee during World War II after being attacked by Japanese aircraft in 1942.
              Resting at a depth of around 20–22 meters, this wreck is one of the East Coast’s most
              popular dive sites. Today, the remains of the ship are scattered but still
              recognizable,creating an artificial reef that shelters an incredible variety of marine
              life. Divers can encounter schools of fusiliers, groupers, lionfish, and sometimes
              even rays gliding past. With relatively shallow depth and good visibility during the
              East Coast season, it’s an ideal site for both recreational divers and underwater
              photographers.
            </MKTypography>
          </Grid>
          <Grid item xs={12} lg={6} sx={{ ml: "auto", mt: { xs: 8, lg: 3 } }}>
            <Card sx={{ maxWidth: 700, borderRadius: 1, boxShadow: 0 }}>
              <CardMedia
                component="img"
                image={ladyMccallum}
                alt="Team Member"
                sx={{ height: 300, objectFit: "cover" }}
              />
              <CardContent>
                <Typography variant="body1" align="center" fontWeight="bold">
                  Lady Macculum
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
      <Container>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} lg={6}>
            <MKTypography variant="h3" mt={-10} mb={0}>
              Catalina Aircraft
            </MKTypography>
            <MKTypography variant="body1" mt={1} mb={0}>
              The Catalina was a British Royal Air Force flying boat used for patrol and
              reconnaissance missions during World War II. In 1942, one of these aircraft was
              attacked and sunk by Japanese forces near Batticaloa, on Sri Lanka’s East Coast.
              Today, its remains rest at around 18–22 meters deep, making it a unique and accessible
              dive site. Though broken into sections, the aircraft’s wings and fuselage can still be
              seen, offering divers a rare chance to explore a WWII seaplane underwater. The wreck
              has since become a haven for marine life, with schools of reef fish, lionfish, and
              small rays often spotted around the structure.
            </MKTypography>
          </Grid>
          <Grid item xs={12} lg={6} sx={{ ml: "auto", mt: { xs: 8, lg: 3 } }}>
            <Card sx={{ maxWidth: 700, borderRadius: 1, boxShadow: 0 }}>
              <CardMedia
                component="img"
                image={CatalinaPlane}
                alt="Team Member"
                sx={{ height: 300, objectFit: "cover" }}
              />
              <CardContent>
                <Typography variant="body1" align="center" fontWeight="bold">
                  Catalina Aircraft
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
      <Container>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} lg={6}>
            <MKTypography variant="h3" mt={-10} mb={0}>
              Ship Graveyard
            </MKTypography>
            <MKTypography variant="body1" mt={1} mb={0}>
              Known as the “Ship Graveyard of Sri Lanka”, this site lies off the coast of Batticaloa
              on the East Coast. It earned its name because of the large concentration of sunken
              ships in a relatively small area. Many of these vessels were casualties of World War
              II, sunk during Japanese air raids in 1942, while others went down due to storms or
              accidents over the years. Resting at depths of around 20–40 meters, the wrecks vary in
              size and condition — some still recognizable, others broken into sections — all now
              serving as artificial reefs teeming with life. This underwater museum is a dream for
              wreck divers, combining history, adventure, and marine biodiversity in one location.
            </MKTypography>
          </Grid>
          <Grid item xs={12} lg={6} sx={{ ml: "auto", mt: { xs: 8, lg: 3 } }}>
            <Card sx={{ maxWidth: 700, borderRadius: 1, boxShadow: 0 }}>
              <CardMedia
                component="img"
                image={ShipGraveyard}
                alt="Team Member"
                sx={{ height: 300, objectFit: "cover" }}
              />
              <CardContent>
                <Typography variant="body1" align="center" fontWeight="bold">
                  Ship Graveyard
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Wrecksite;
